<template>
  <div class="full-height">
    <crud-layout
      ref="crudLayout"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page="page"
      @composition-button-click="actionButton"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import ConcessionContractPage from './ConcessionContractPage.vue'
import { repository } from 'jtech'

const CrudLayout = JtCrud.CrudLayout

@Component({
  name: 'ConcessionContract',
  components: { CrudLayout, ConcessionContractPage },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ConcessionContract extends Vue {
  get nmInterface () {
    return this.interface
  }

  get page () {
    return ConcessionContractPage
  }

  async btAlterar ({ button, params, page, controller }) {
    const id = page.params ? page.params.id : params.id
    await repository.update(button.action, { ...params, id: id })
    this.$refs.crudLayout.removePage(page)
  }

  async btGravar ({ button, params, page, controller }) {
    await repository.create(button.action, params)
    page.limparForm()
  }

  async actionButton ({ button, params, composition }) {
    if (button.name == 'icUnitsReprocess') {
      await repository.resolveLogic(
        'concessionContractTariff.unitsReprocess',
        params
      )
    } else if (button.name == 'icUnitsProcess') {
      await repository.resolveLogic(
        'concessionContractTariff.unitsProcess',
        params
      )
    } else if (button.name == 'icCreatePaymentVouchers') {
      await repository.resolveLogic('createPaymentVouchers.create', params)
    } else if (button.name == 'icDownloadPaymentVouchers') {
      const data = await repository.resolveLogic(
        'createPaymentVouchers.download',
        params
      )
      const name = data.file
      const file = await repository.downloadFile(
        name,
        null,
        'PAYMENT_VOUCHERS',
        'application/octet-stream'
      )
      const link = document.createElement('a')
      link.download = name
      link.href = URL.createObjectURL(file)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else if (button.name == 'icSendEmailOnePaymentType') {
      await repository.resolveLogic('sendEmailOnePaymentTime.startProcess', params)
    }
  }

  mounted () {
    try {
      this.$refs.crudLayout.onButton('btAlterar', this.btAlterar)
      this.$refs.crudLayout.onButton('btGravar', this.btGravar)
    } catch (error) {
      console.error(error)
    }
  }
}
export default ConcessionContract
</script>
<style lang="stylus" scoped></style>
